var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessibilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    width: 16.7742,
    height: 16.7742,
    rx: 8.3871,
    fill: "#041F3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61505 2.58203C9.32472 2.58203 9.90537 3.10461 9.90537 3.74332C9.90537 4.38203 9.32472 4.90461 8.61505 4.90461C7.90537 4.90461 7.32472 4.38203 7.32472 3.74332C7.32472 3.10461 7.90537 2.58203 8.61505 2.58203ZM13.7763 6.64655H10.5505V13.6143C10.5505 13.9336 10.2602 14.1949 9.90537 14.1949C9.55053 14.1949 9.26021 13.9336 9.26021 13.6143V10.7111H7.96988V13.6143C7.96988 13.9336 7.67956 14.1949 7.32472 14.1949C6.96988 14.1949 6.67956 13.9336 6.67956 13.6143V6.64655H3.45376C3.09892 6.64655 2.80859 6.38526 2.80859 6.0659C2.80859 5.74655 3.09892 5.48526 3.45376 5.48526H13.7763C14.1312 5.48526 14.4215 5.74655 14.4215 6.0659C14.4215 6.38526 14.1312 6.64655 13.7763 6.64655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityIcon);
export default __webpack_public_path__ + "static/media/accessibilityIcon.3c2ee2a68dc51ba0915b8cd756b9a839.svg";
export { ForwardRef as ReactComponent };